import React from 'react';
import { useLocation } from 'react-router-dom';

export default function LegacyAuthEntry({ children = null }) {
  const { pathname } = useLocation();
  // React Router matches /auth and /auth/ alike; the served entry points differ.
  const keepCurrentEntry = pathname === '/auth';
  React.useEffect(() => {
    if (!keepCurrentEntry) window.location.replace('/index.html');
  }, [keepCurrentEntry]);
  return keepCurrentEntry ? children : null;
}
